// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Contravariant_Compat from "../Data.Functor.Contravariant.Compat/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_NamedParams from "../Data.NamedParams/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Timer from "../Effect.Timer/index.js";
import * as Restaumatic_Components_MultiSelect from "../Restaumatic.Components.MultiSelect/index.js";
import * as Restaumatic_Form from "../Restaumatic.Form/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_List from "../Restaumatic.Form.List/index.js";
import * as Restaumatic_Form_Mapping from "../Restaumatic.Form.Mapping/index.js";
import * as Restaumatic_Form_Optional from "../Restaumatic.Form.Optional/index.js";
import * as Restaumatic_Form_Translated from "../Restaumatic.Form.Translated/index.js";
import * as Restaumatic_Form_Widgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Widget from "../Specular.Dom.Widget/index.js";
import * as Specular_Extra from "../Specular.Extra/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Extra from "../Specular.FRP.Extra/index.js";
import * as Specular_JQuery from "../Specular.JQuery/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
var UseDefault = /* #__PURE__ */ (function () {
    function UseDefault() {

    };
    UseDefault.value = new UseDefault();
    return UseDefault;
})();
var LabelDefault = /* #__PURE__ */ (function () {
    function LabelDefault() {

    };
    LabelDefault.value = new LabelDefault();
    return LabelDefault;
})();
var LabelBooleanControl = /* #__PURE__ */ (function () {
    function LabelBooleanControl() {

    };
    LabelBooleanControl.value = new LabelBooleanControl();
    return LabelBooleanControl;
})();
var toGroupNameUseDefault = {
    toGroupName: function (v) {
        return v.fieldId;
    }
};
var toGroupNameString = {
    toGroupName: function (v) {
        return v.value;
    }
};
var wrapItem = /* #__PURE__ */ Specular_Dom_Element.el("div")([ /* #__PURE__ */ Specular_Dom_Element.attr("style")("margin: 5px; margin-left: 10px; padding: 5px; border: 1px solid black;") ]);
var withNothing = function (emptyLabel) {
    return function (opts) {
        return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Restaumatic_Form.singleOption(emptyLabel)(Data_Maybe.Nothing.value) ])(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Specular_Select.functorOption)(Data_Maybe.Just.create))(opts));
    };
};
var translatedFieldWrapper = function (body) {
    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("input-group") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("span")([ Specular_Dom_Element.attr("title")("Pole t\u0142umaczone"), Specular_Dom_Element.class_("input-group-addon") ])(Specular_Dom_Element.el("span")([ Specular_Dom_Element.attr("aria-hidden")("true"), Specular_Dom_Element.class_("icon-flag") ])(Restaumatic_Prelude_Specular.wempty)))(function () {
        return body;
    }));
};
var toGroupName = function (dict) {
    return dict.toGroupName;
};
var toArray = function (dict) {
    return dict.toArray;
};
var sortIcon = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(/* #__PURE__ */ Specular_Dom_Element.el("i")([ /* #__PURE__ */ Specular_Dom_Element.class_("icon-sort") ])(Restaumatic_Prelude_Specular.wempty))(function () {
    return Specular_Extra.nbsp;
});
var selectorWidget = function (dictShow) {
    return function (dictEq) {
        return function (settings) {
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element["el$prime"]("input")([ Specular_Dom_Element.attr("placeholder")(settings.placeholder) ])(Restaumatic_Prelude_Specular.wempty))(function (v) {
                var jq = Specular_JQuery.fromNode(v.value0);
                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(Data_Functor["void"](Effect.functorEffect)(Effect_Timer.setTimeout(0)(function __do() {
                    Restaumatic_Components_MultiSelect.initSelect2()(jq)({
                        data: function __do() {
                            var opts = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(settings.options)();
                            return {
                                results: Restaumatic_Components_MultiSelect.fromSelectOptions(dictShow)(opts)
                            };
                        },
                        containerCssClass: "form-control",
                        multiple: true,
                        placeholder: settings.placeholder,
                        shouldFocusInput: function (v1) {
                            return settings.openAfterSelection;
                        }
                    })();
                    return Restaumatic_Components_MultiSelect.setValues(jq)([  ])();
                }))))(function () {
                    var onChange = function (v1) {
                        return function __do() {
                            var entries = Restaumatic_Components_MultiSelect.getValues(jq)();
                            Restaumatic_Components_MultiSelect.setValues(jq)([  ])();
                            (function () {
                                var v2 = Data_Array.head(entries);
                                if (v2 instanceof Data_Maybe.Just) {
                                    return settings.onSelect(v2.value0.option)();
                                };
                                return Data_Unit.unit;
                            })();
                            return Control_Applicative.when(Effect.applicativeEffect)(settings.openAfterSelection)(Restaumatic_Components_MultiSelect.open(jq))();
                        };
                    };
                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(Specular_JQuery.addEventListener("change")(onChange)(jq)))(function (unsub) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Control_Monad_Cleanup.onCleanup(Specular_Dom_Builder.monadCleanupBuilder)(unsub))(function () {
                            return Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(Control_Applicative.when(Effect.applicativeEffect)(settings.openOnInit)(Data_Functor["void"](Effect.functorEffect)(Effect_Timer.setTimeout(0)(Restaumatic_Components_MultiSelect.open(jq)))));
                        });
                    });
                });
            });
        };
    };
};
var renderLabelWithMode = function (dict) {
    return dict.renderLabelWithMode;
};
var renderLabel = function (dictFieldLabel) {
    return renderLabelWithMode(dictFieldLabel)(LabelDefault.value);
};
var plusIcon = /* #__PURE__ */ Control_Apply.applySecond(Specular_Dom_Builder.applyBuilder)(/* #__PURE__ */ Specular_Dom_Element.el("span")([ /* #__PURE__ */ Specular_Dom_Element.attr("aria-hidden")("true"), /* #__PURE__ */ Specular_Dom_Element.class_("icon-plus-sign") ])(Restaumatic_Prelude_Specular.wempty))(Specular_Extra.nbsp);
var panelToggle = function (label1) {
    return function (forceExpand) {
        return function (body) {
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Base.readDynamic(Specular_Dom_Builder.monadEffectBuilder)(forceExpand))(Specular_Ref.newRef(Specular_Dom_Builder.monadEffectBuilder)))(function (expanded) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Callback.attachDyn(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(forceExpand)(Data_Functor_Contravariant_Compat.cmap(function (a) {
                    return function (b) {
                        return a || b;
                    };
                })(Specular_Ref.modify(Effect_Class.monadEffectEffect)(expanded))))(function () {
                    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel"), Specular_Dom_Element.class_("panel-default") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel-heading"), Specular_Dom_Element.class_("sortable-handle") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Extra.unlessD(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(forceExpand)(Specular_Dom_Element.el("button")([ Specular_Dom_Element.onClick_(Specular_Ref.modify(Effect_Class.monadEffectEffect)(expanded)(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean))), Specular_Dom_Element.attr("type")("button"), Specular_Dom_Element.class_("btn"), Specular_Dom_Element.class_("btn-default"), Specular_Dom_Element.class_("btn-sm"), Specular_Dom_Element.class_("pull-right") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("span")([ Specular_Dom_Element.attr("aria-hidden")("true"), Specular_Dom_Element.classWhenD(Specular_Ref.value(expanded))("icon-caret-up"), Specular_Dom_Element.classUnlessD(Specular_Ref.value(expanded))("icon-caret-down") ])(Restaumatic_Prelude_Specular.wempty))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Extra.nbsp)(function () {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Extra.whenD(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(Specular_Ref.value(expanded))(Specular_Dom_Element.text("Zwi\u0144")))(function () {
                                return Specular_FRP_Extra.unlessD(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(Specular_Ref.value(expanded))(Specular_Dom_Element.text("Rozwi\u0144"));
                            });
                        });
                    }))))(function () {
                        return label1;
                    })))(function () {
                        return Specular_FRP_Extra.whenD(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(Specular_Ref.value(expanded))(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel-body") ])(body));
                    }));
                });
            });
        };
    };
};
var panel$prime = function (label1) {
    return function (body) {
        return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel"), Specular_Dom_Element.class_("panel-default") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel-heading"), Specular_Dom_Element.class_("sortable-handle") ])(label1))(function () {
            return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel-body") ])(body);
        }));
    };
};
var panel = function (classes$prime) {
    return function (body) {
        return Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ "panel", "panel-default" ])(classes$prime)) ])(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel-body") ])(body));
    };
};
var panel_ = function (body) {
    return panel(Data_Monoid.mempty(Data_Monoid.monoidArray))(body);
};
var mappingField = function (dictOrd) {
    return function (dictFieldLabel) {
        return function (label1) {
            return function (f) {
                return function (renderItem) {
                    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes([ "form-group" ]) ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(renderLabel(dictFieldLabel)(label1))(function () {
                        return Restaumatic_Form_Mapping.display(dictOrd)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(f)(renderItem);
                    }));
                };
            };
        };
    };
};
var labelWidget = function (dictTypeEquals) {
    return {
        renderLabelWithMode: function (v) {
            return Specular_Dom_Builder.local(Type_Equality.from(dictTypeEquals));
        },
        isVisible: function (v) {
            return function (v1) {
                return true;
            };
        }
    };
};
var labelUnit = {
    renderLabelWithMode: function (v) {
        return function (v1) {
            return Restaumatic_Prelude_Specular.wempty;
        };
    },
    isVisible: function (v) {
        return function (v1) {
            return false;
        };
    }
};
var label = /* #__PURE__ */ Specular_Dom_Element.el("label")([ /* #__PURE__ */ Specular_Dom_Element.class_("control-label") ]);
var labelString = {
    renderLabelWithMode: function (v) {
        return function (v1) {
            if (v1 === "") {
                return Restaumatic_Prelude_Specular.wempty;
            };
            if (v instanceof LabelDefault) {
                return label(Specular_Dom_Element.text(v1));
            };
            if (v instanceof LabelBooleanControl) {
                return Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("control-label") ])(Specular_Dom_Element.text(v1));
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Widgets.Bootstrap (line 49, column 1 - line 58, column 23): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    isVisible: function (v) {
        return function (v1) {
            if (v instanceof LabelDefault && v1 === "") {
                return false;
            };
            return true;
        };
    }
};
var isVisible = function (dict) {
    return dict.isVisible;
};
var infoText = /* #__PURE__ */ Specular_Dom_Element.el("p")([ /* #__PURE__ */ Specular_Dom_Element.class_("m-form__info-text") ]);
var fromArray = function (dict) {
    return dict.fromArray;
};
var formGroup = function (label1) {
    return function (body) {
        return Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes([ "form-group" ]) ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Control_Applicative.when(Specular_Dom_Builder.applicativeBuilder)(label1 !== "")(Specular_Dom_Element.el("label")([ Specular_Dom_Element.class_("control-label") ])(Specular_Dom_Element.text(label1))))(function () {
            return body;
        }));
    };
};
var fieldset$prime = function (label1) {
    return function (body) {
        return Specular_Dom_Element.el("fieldset")([ Specular_Dom_Element.class_("form-fieldset") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el_("legend")(label1))(function () {
            return body;
        }));
    };
};
var fieldset = function (label1) {
    return fieldset$prime(Specular_Dom_Element.text(label1));
};
var displayErrors = function (dictHasErrors) {
    return function (f) {
        return Specular_FRP_Extra.withUniqDynamic_(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(Data_Eq.eqArray(Data_Eq.eqString))(Restaumatic_Form.displayedErrors(dictHasErrors)(f))(function (errors) {
            return Data_Foldable.for_(Specular_Dom_Builder.applicativeBuilder)(Data_Foldable.foldableArray)(errors)(function (error) {
                return Specular_Dom_Element.el("p")([ Specular_Dom_Element.class_("help-block") ])(Specular_Dom_Element.text(error));
            });
        });
    };
};
var multiSelectField = function () {
    return function (dictContainer) {
        return function (dictFieldLabel) {
            return function (dictShow) {
                return function (dictEq) {
                    return function () {
                        return function () {
                            return Data_NamedParams.mkNamedParamsFn()()({
                                label: "",
                                placeholder: ""
                            })(function (v) {
                                return Specular_Dom_Element.el("div")([ Restaumatic_Form_Widgets.fieldId(Restaumatic_Form.hasFieldIdFormField1)(v.field), Specular_Dom_Element.class_("form-field"), Specular_Dom_Element.classWhenD(Restaumatic_Form.hasDisplayedErrors(Restaumatic_Form.hasErrorsFormField)(v.field))("has-error") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(renderLabel(dictFieldLabel)(v.label))(function () {
                                    var entriesD = Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(Restaumatic_Form.readOptions()(v.field))(Specular_Select.flattenOptionsWith(function (x) {
                                        return {
                                            id: Data_Show.show(dictShow)(x.key),
                                            option: x.key,
                                            text: x.label
                                        };
                                    }));
                                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element["el$prime"]("input")([  ])(Specular_Dom_Widget.emptyWidget))(function (v1) {
                                        var jq = Specular_JQuery.fromNode(v1.value0);
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(Restaumatic_Components_MultiSelect.initSelect2()(jq)({
                                            data: Data_Functor.map(Effect.functorEffect)(function (xs) {
                                                return {
                                                    results: Data_Functor.map(Data_Functor.functorArray)(Restaumatic_Components_MultiSelect.entry)(xs)
                                                };
                                            })(Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(entriesD)),
                                            containerCssClass: "form-control",
                                            multiple: true,
                                            placeholder: v.placeholder
                                        })))(function () {
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Data_Function.flip(Specular_FRP_Base.subscribeDyn_(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder)))(Restaumatic_Form_Final.unFinal(Restaumatic_Form.readValue(v.field)))(function (m_values) {
                                                return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(m_values)(function (values) {
                                                    return function __do() {
                                                        var entries = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(entriesD)();
                                                        var toEntry = function (x) {
                                                            return Data_Maybe.fromMaybe({
                                                                id: Data_Show.show(dictShow)(x),
                                                                option: x,
                                                                text: Data_Show.show(dictShow)(x)
                                                            })(Data_Array.find(function (e) {
                                                                return Data_Eq.eq(dictEq)(e.option)(x);
                                                            })(entries));
                                                        };
                                                        return Restaumatic_Components_MultiSelect.setValues(jq)(Data_Functor.map(Data_Functor.functorArray)(toEntry)(toArray(dictContainer)(values)))();
                                                    };
                                                });
                                            }))(function () {
                                                var onChange = function (v2) {
                                                    return function __do() {
                                                        var entries = Restaumatic_Components_MultiSelect.getValues(jq)();
                                                        return Restaumatic_Form.writeValidValue(v.field)(fromArray(dictContainer)(Data_Functor.map(Data_Functor.functorArray)(function (v3) {
                                                            return v3.option;
                                                        })(entries)))();
                                                    };
                                                };
                                                return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(Specular_JQuery.addEventListener("change")(onChange)(jq)))(function (unsub) {
                                                    return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Control_Monad_Cleanup.onCleanup(Specular_Dom_Builder.monadCleanupBuilder)(unsub))(function () {
                                                        return displayErrors(Restaumatic_Form.hasErrorsFormField)(v.field);
                                                    });
                                                });
                                            });
                                        });
                                    });
                                }));
                            });
                        };
                    };
                };
            };
        };
    };
};
var radioGroup = function () {
    return function (dictHasErrors) {
        return function (dictIsSelectField) {
            return function (dictToOptionId) {
                return function (dictHasFieldId) {
                    return function (dictFieldLabel) {
                        return function (dictToGroupName) {
                            return function (dictShow) {
                                return function (dictEq) {
                                    return function () {
                                        return function () {
                                            return Data_NamedParams.mkNamedParamsFn()()({
                                                label: "",
                                                props: [  ],
                                                groupName: UseDefault.value
                                            })(function (params) {
                                                return Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes([ "form-group", "form-field" ]), Restaumatic_Form_Widgets.fieldId(dictHasFieldId)(params.field), Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringProp)("data-field-type")("radioGroup"), Specular_Dom_Element.classWhenD(Restaumatic_Form.hasDisplayedErrors(dictHasErrors)(params.field))("has-error") ])(Specular_FRP_Extra.withUniqDynamic_(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(Data_Eq.eqArray(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                                                    reflectSymbol: function () {
                                                        return "label";
                                                    }
                                                })(Data_Eq.eqString))()({
                                                    reflectSymbol: function () {
                                                        return "key";
                                                    }
                                                })(dictEq))()({
                                                    reflectSymbol: function () {
                                                        return "disabled";
                                                    }
                                                })(Data_Eq.eqBoolean))))(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Specular_Select.flattenOptions)(Restaumatic_Form.selectGetOptions(dictIsSelectField)(params.field)))(function (opts) {
                                                    return Data_Foldable.for_(Specular_Dom_Builder.applicativeBuilder)(Data_Foldable.foldableArray)(opts)(function (option) {
                                                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("radio"), Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringProp)("data-option-id")(Specular_Select.toOptionId(dictToOptionId)(option.key)) ])(Specular_Dom_Element.el_("label")(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Restaumatic_Form_Widgets.radio(dictShow)(dictEq)(dictIsSelectField)(toGroupName(dictToGroupName)({
                                                            fieldId: Restaumatic_Form.getFieldId(dictHasFieldId)(params.field),
                                                            value: params.groupName
                                                        }))(option)(params.props)(params.field))(function () {
                                                            return renderLabelWithMode(labelString)(LabelBooleanControl.value)(option.label);
                                                        }))))(function () {
                                                            return displayErrors(dictHasErrors)(params.field);
                                                        });
                                                    });
                                                }));
                                            });
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var selectField = function () {
    return function (dictIsSelectField) {
        return function (dictHasErrors) {
            return function (dictHasFieldId) {
                return function (dictFieldLabel) {
                    return function (dictShow) {
                        return function (dictEq) {
                            return function (dictToOptionId) {
                                return function () {
                                    return function () {
                                        return Data_NamedParams.mkNamedParamsFn()()({
                                            label: "",
                                            props: [  ]
                                        })(function (params) {
                                            return Specular_Dom_Element.el("div")([ Restaumatic_Form_Widgets.fieldId(dictHasFieldId)(params.field), Specular_Dom_Element.class_("form-field"), Specular_Dom_Element.classWhenD(Restaumatic_Form.hasDisplayedErrors(dictHasErrors)(params.field))("has-error") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(renderLabel(dictFieldLabel)(params.label))(function () {
                                                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Restaumatic_Form_Widgets.select(dictShow)(dictEq)(dictToOptionId)(dictIsSelectField)(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Specular_Dom_Element.class_("form-control") ])(params.props))(params.field))(function () {
                                                    return displayErrors(dictHasErrors)(params.field);
                                                });
                                            }));
                                        });
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var tagsField = function (dictContainer) {
    return function (dictFieldLabel) {
        return function (dictIsRefLike) {
            return function (dictHasErrors) {
                return function (dictHasFieldId) {
                    return function () {
                        return function () {
                            return Data_NamedParams.mkNamedParamsFn()()({
                                label: "",
                                placeholder: ""
                            })(function (params) {
                                return Specular_Dom_Element.el("div")([ Restaumatic_Form_Widgets.fieldId(dictHasFieldId)(params.field), Specular_Dom_Element.classes([ "form-group", "form-field" ]), Specular_Dom_Element.classWhenD(Restaumatic_Form.hasDisplayedErrors(dictHasErrors)(params.field))("has-error") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(renderLabel(dictFieldLabel)(params.label))(function () {
                                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element["el$prime"]("input")([  ])(Restaumatic_Prelude_Specular.wempty))(function (v) {
                                        var jq = Specular_JQuery.fromNode(v.value0);
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(Restaumatic_Components_MultiSelect.initSelect2()(jq)({
                                            tags: [  ],
                                            containerCssClass: "form-control",
                                            multiple: true,
                                            placeholder: params.placeholder,
                                            formatNoMatches: function (v1) {
                                                return params.placeholder;
                                            }
                                        })))(function () {
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Data_Function.flip(Specular_FRP_Base.subscribeDyn_(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder)))(Restaumatic_Form.readRefLike(dictIsRefLike)(params.field))(function (m_values) {
                                                return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(m_values)(function (values) {
                                                    var toEntry = function (ix) {
                                                        return function (str) {
                                                            return {
                                                                id: Data_Show.show(Data_Show.showInt)(ix),
                                                                option: "",
                                                                text: str
                                                            };
                                                        };
                                                    };
                                                    return Restaumatic_Components_MultiSelect.setValues(jq)(Data_Array.mapWithIndex(toEntry)(toArray(dictContainer)(values)));
                                                });
                                            }))(function () {
                                                var onChange = function (v1) {
                                                    return function __do() {
                                                        var entries = Restaumatic_Components_MultiSelect.getValues(jq)();
                                                        return Restaumatic_Form.writeRefLike(dictIsRefLike)(params.field)(new Restaumatic_Form.Valid({
                                                            value: fromArray(dictContainer)(Data_Functor.map(Data_Functor.functorArray)(function (v2) {
                                                                return v2.text;
                                                            })(entries)),
                                                            editValue: Data_Maybe.Nothing.value
                                                        }))();
                                                    };
                                                };
                                                return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(Specular_JQuery.addEventListener("change")(onChange)(jq)))(function (unsub) {
                                                    return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Control_Monad_Cleanup.onCleanup(Specular_Dom_Builder.monadCleanupBuilder)(unsub))(function () {
                                                        return displayErrors(dictHasErrors)(params.field);
                                                    });
                                                });
                                            });
                                        });
                                    });
                                }));
                            });
                        };
                    };
                };
            };
        };
    };
};
var textField$prime = function (dictHasErrors) {
    return function (dictHasFieldId) {
        return function (dictFieldLabel) {
            return function (widget) {
                return function (params) {
                    var labelVisible = isVisible(dictFieldLabel)(LabelDefault.value)(params.label);
                    return Specular_Dom_Element.el("div")([ Restaumatic_Form_Widgets.fieldId(dictHasFieldId)(params.field), Specular_Dom_Element.classes([ "form-group", "form-field" ]), Specular_Dom_Element.classWhenD(Restaumatic_Form.hasDisplayedErrors(dictHasErrors)(params.field))("has-error"), Specular_Dom_Element.classUnless(labelVisible)("form-field--inline") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Control_Applicative.when(Specular_Dom_Builder.applicativeBuilder)(labelVisible)(renderLabel(dictFieldLabel)(params.label)))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(params.wrapper(widget(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Specular_Dom_Element.class_("form-control") ])(params.props))(params.field)))(function () {
                            return displayErrors(dictHasErrors)(params.field);
                        });
                    }));
                };
            };
        };
    };
};
var textAreaField = function (dictHasErrors) {
    return function (dictFieldLabel) {
        return function (dictIsTextField) {
            return function (dictHasFieldId) {
                return function () {
                    return function () {
                        return Data_NamedParams.mkNamedParamsFn()()({
                            label: "",
                            props: [  ],
                            wrapper: Control_Category.identity(Control_Category.categoryFn)
                        })(textField$prime(dictHasErrors)(dictHasFieldId)(dictFieldLabel)(Restaumatic_Form_Widgets.textArea(dictIsTextField)));
                    };
                };
            };
        };
    };
};
var textField = function (dictHasErrors) {
    return function (dictFieldLabel) {
        return function (dictIsTextField) {
            return function (dictHasFieldId) {
                return function () {
                    return function () {
                        return Data_NamedParams.mkNamedParamsFn()()({
                            label: "",
                            props: [  ],
                            wrapper: Control_Category.identity(Control_Category.categoryFn)
                        })(textField$prime(dictHasErrors)(dictHasFieldId)(dictFieldLabel)(Restaumatic_Form_Widgets.textInput(dictIsTextField)));
                    };
                };
            };
        };
    };
};
var translatedTextAreaField = function (dictAsTranslatedString) {
    return function (dictFieldLabel) {
        return function () {
            return function () {
                return Data_NamedParams.mkNamedParamsFn()()({
                    label: "",
                    props: [  ],
                    wrapper: translatedFieldWrapper
                })(function (params) {
                    return textField$prime(Restaumatic_Form_Translated.hasErrorsTranslatedFormFi(dictAsTranslatedString))(Restaumatic_Form_Translated.hasFieldIdTranslatedFormF)(dictFieldLabel)(Restaumatic_Form_Widgets.textArea(Restaumatic_Form_Translated.isTextFieldTranslatedFormField(dictAsTranslatedString)))({
                        field: params.field,
                        label: params.label,
                        props: params.props,
                        wrapper: params.wrapper
                    });
                });
            };
        };
    };
};
var translatedTextField = function (dictAsTranslatedString) {
    return function (dictFieldLabel) {
        return function () {
            return function () {
                return Data_NamedParams.mkNamedParamsFn()()({
                    label: "",
                    props: [  ],
                    wrapper: translatedFieldWrapper
                })(function (params) {
                    return textField$prime(Restaumatic_Form_Translated.hasErrorsTranslatedFormFi(dictAsTranslatedString))(Restaumatic_Form_Translated.hasFieldIdTranslatedFormF)(dictFieldLabel)(Restaumatic_Form_Widgets.textInput(Restaumatic_Form_Translated.isTextFieldTranslatedFormField(dictAsTranslatedString)))({
                        field: params.field,
                        label: params.label,
                        props: params.props,
                        wrapper: params.wrapper
                    });
                });
            };
        };
    };
};
var deleteButton = function (dictEq) {
    return function (item) {
        return Specular_Dom_Element.el("button")([ Specular_Dom_Element.classes([ "btn", "btn-default", "btn-sm" ]), Specular_Dom_Element.attr("type")("button"), Specular_Dom_Element.onClick_(Restaumatic_Form_List.deleteItem(dictEq)(item)) ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Control_Apply.applySecond(Specular_Dom_Builder.applyBuilder)(Specular_Dom_Element.el("span")([ Specular_Dom_Element.attr("aria-hidden")("true"), Specular_Dom_Element.class_("icon-trash") ])(Restaumatic_Prelude_Specular.wempty))(Specular_Extra.nbsp))(function () {
            return Specular_Dom_Element.text("Usu\u0144");
        }));
    };
};
var dateField = function (dictIsRefLike) {
    return function (dictHasErrors) {
        return function (dictAsDate) {
            return function (dictFieldLabel) {
                return function (dictHasFieldId) {
                    return function () {
                        return function () {
                            return Data_NamedParams.mkNamedParamsFn()()({
                                label: "",
                                placeholder: "",
                                props: [  ]
                            })(function (params) {
                                return textField$prime(dictHasErrors)(dictHasFieldId)(dictFieldLabel)(Restaumatic_Form_Widgets.datePicker(dictIsRefLike)(dictAsDate))({
                                    field: params.field,
                                    label: params.label,
                                    props: [ Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringProp)("placeholder")(params.placeholder), Data_Foldable.fold(Data_Foldable.foldableArray)(Specular_Dom_Element.monoidProp)(params.props) ],
                                    wrapper: Control_Category.identity(Control_Category.categoryFn)
                                });
                            });
                        };
                    };
                };
            };
        };
    };
};
var containerSet = function (dictOrd) {
    return {
        fromArray: (function () {
            var $124 = Data_Newtype.wrap();
            var $125 = Data_Set.fromFoldable(Data_Foldable.foldableArray)(dictOrd);
            return function ($126) {
                return $124($125($126));
            };
        })(),
        toArray: (function () {
            var $127 = Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray);
            var $128 = Data_Newtype.unwrap();
            return function ($129) {
                return $127($128($129));
            };
        })(),
        Monoid0: function () {
            return Data_Set_Serialized.monoidSet(dictOrd);
        }
    };
};
var containerArray = {
    fromArray: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn),
    toArray: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn),
    Monoid0: function () {
        return Data_Monoid.monoidArray;
    }
};
var checkbox = function (dictFieldLabel) {
    return function (dictIsCheckboxField) {
        return function () {
            return function () {
                return Data_NamedParams.mkNamedParamsFn()()({
                    label: "",
                    props: [  ]
                })(function (params) {
                    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("checkbox") ])(Specular_Dom_Element.el_("label")(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Restaumatic_Form_Widgets.checkbox(dictIsCheckboxField)(params.props)(params.field))(function () {
                        return renderLabelWithMode(dictFieldLabel)(LabelBooleanControl.value)(params.label);
                    })));
                });
            };
        };
    };
};
var checkboxField = function (dictFieldLabel) {
    return function (dictFieldLabel1) {
        return function (dictIsCheckboxField) {
            return function (dictHasErrors) {
                return function (dictHasFieldId) {
                    return function () {
                        return function () {
                            return Data_NamedParams.mkNamedParamsFn()()({
                                label: "",
                                title: "",
                                props: [  ]
                            })(function (params) {
                                return Specular_Dom_Element.el("div")([ Restaumatic_Form_Widgets.fieldId(dictHasFieldId)(params.field), Specular_Dom_Element.classes([ "form-group", "form-field" ]), Specular_Dom_Element.classWhenD(Restaumatic_Form.hasDisplayedErrors(dictHasErrors)(params.field))("has-error") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Control_Applicative.when(Specular_Dom_Builder.applicativeBuilder)(isVisible(dictFieldLabel1)(LabelDefault.value)(params.title))(renderLabelWithMode(dictFieldLabel1)(LabelBooleanControl.value)(params.title)))(function () {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(checkbox(dictFieldLabel)(dictIsCheckboxField)()()({
                                        label: params.label,
                                        props: params.props,
                                        field: params.field
                                    }))(function () {
                                        return displayErrors(dictHasErrors)(params.field);
                                    });
                                }));
                            });
                        };
                    };
                };
            };
        };
    };
};
var optionalWidget = function (label1) {
    return function (f) {
        return function (renderSubform) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(checkboxField(labelString)(labelString)(Restaumatic_Form.isCheckboxFieldFormFieldB1)(Restaumatic_Form.hasErrorsFormField)(Restaumatic_Form.hasFieldIdFormField1)()()({
                label: label1,
                field: Restaumatic_Form_Optional.exists(f)
            }))(function () {
                return Specular_FRP_Extra.whenD(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(Restaumatic_Form.queryLaxWithDefault(Restaumatic_Form.queryFormFieldI(Type_Equality.refl))(false)(Restaumatic_Form_Optional.exists(f)))(renderSubform(Restaumatic_Form_Optional.subform(f)));
            });
        };
    };
};
var alertWarning = /* #__PURE__ */ Specular_Dom_Element.el("div")([ /* #__PURE__ */ Specular_Dom_Element.class_("alert"), /* #__PURE__ */ Specular_Dom_Element.class_("alert-warning") ]);
var displayAlertWarning = function (dictHasErrors) {
    return function (f) {
        return Specular_FRP_Extra.withUniqDynamic_(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(Data_Eq.eqArray(Data_Eq.eqString))(Restaumatic_Form.displayedErrors(dictHasErrors)(f))(function (errors) {
            return Data_Foldable.for_(Specular_Dom_Builder.applicativeBuilder)(Data_Foldable.foldableArray)(errors)(function (error) {
                return alertWarning(Specular_Dom_Element.text(error));
            });
        });
    };
};
var alertInfo = /* #__PURE__ */ Specular_Dom_Element.el("div")([ /* #__PURE__ */ Specular_Dom_Element.class_("alert"), /* #__PURE__ */ Specular_Dom_Element.class_("alert-info") ]);
var addItemWidget = function (dictShow) {
    return function (dictEq) {
        return function (settings) {
            return function (field) {
                return selectorWidget(dictShow)(dictEq)({
                    placeholder: settings.placeholder,
                    options: Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
                        return function (v1) {
                            return Specular_Select.filterOptions(function (x) {
                                return Data_Array.notElem(dictEq)(x)(v);
                            })(v1);
                        };
                    })(Restaumatic_Form.unFinalWithDefault(Data_Monoid.mempty(Data_Monoid.monoidArray))(Restaumatic_Form.queryLax(Restaumatic_Form.queryFormFieldI(Type_Equality.refl))(field))))(Restaumatic_Form.readOptions()(field)),
                    onSelect: function (option) {
                        return Restaumatic_Form.modifyValidValue(field)((function () {
                            var $130 = Data_Maybe.fromMaybe(Data_Monoid.mempty(Data_Monoid.monoidArray));
                            return function ($131) {
                                return (function (v) {
                                    return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v)([ option ]);
                                })($130($131));
                            };
                        })());
                    },
                    openAfterSelection: true,
                    openOnInit: false
                });
            };
        };
    };
};
var addButton = function (dictShow) {
    return function (l) {
        return Specular_Dom_Element.el("button")([ Specular_Dom_Element.classes([ "btn", "btn-default", "btn-sm" ]), Specular_Dom_Element.attr("type")("button"), Specular_Dom_Element.onClick_(Restaumatic_Form_List.pushItemCb(dictShow)(l)) ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(plusIcon)(function () {
            return Specular_Dom_Element.text("Dodaj");
        }));
    };
};
export {
    LabelDefault,
    LabelBooleanControl,
    UseDefault,
    addButton,
    addItemWidget,
    alertInfo,
    alertWarning,
    checkbox,
    checkboxField,
    dateField,
    deleteButton,
    displayAlertWarning,
    displayErrors,
    fieldset,
    fieldset$prime,
    formGroup,
    fromArray,
    infoText,
    isVisible,
    label,
    mappingField,
    multiSelectField,
    optionalWidget,
    panel,
    panel$prime,
    panelToggle,
    panel_,
    plusIcon,
    radioGroup,
    renderLabel,
    renderLabelWithMode,
    selectField,
    selectorWidget,
    sortIcon,
    tagsField,
    textAreaField,
    textField,
    textField$prime,
    toArray,
    toGroupName,
    translatedFieldWrapper,
    translatedTextAreaField,
    translatedTextField,
    withNothing,
    wrapItem,
    labelString,
    labelUnit,
    labelWidget,
    toGroupNameUseDefault,
    toGroupNameString,
    containerArray,
    containerSet
};
export {
    fieldId,
    fieldWrapper
} from "../Restaumatic.Form.Widgets/index.js";
//# sourceMappingURL=index.js.map
